import React, { FC } from "react";
import { OptimizelyExperimentation } from "../BookingButton/OptimizelyExperimentation.csharp";
import { useFeatureFlags } from "../../Context/FeatureFlagsContext";

export interface HeroPriceProps {
  priceText: string;
  fontColor: string;
  optimizelyExperimentation: OptimizelyExperimentation;
}
export const HeroPrice: FC<HeroPriceProps> = ({
  priceText,
  fontColor,
  optimizelyExperimentation,
}) => {
  const { isFeatureEnabled } = useFeatureFlags();

  const decision = isFeatureEnabled(
    optimizelyExperimentation?.flags.enableNewBookingFlow ?? ""
  );

  return decision ? (
    <span className="HeroPrice" style={{ color: fontColor }}>
      {priceText}
    </span>
  ) : null;
};
